import React from 'react'
import { Badge } from '@/shared/ui'
import type { RewardsLinkStatus } from '../types'

export default function RewardsLinkStatusBadge({ status }: { status: RewardsLinkStatus }) {
  const { label, color } = React.useMemo(() => {
    switch (status) {
      case 'linked':
        return { label: 'Vinculado', color: 'success' as const }
      case 'awaiting':
        return { label: 'Aguardando vinculação', color: 'warning' as const }
      case 'syncing':
        return { label: 'Sincronizando', color: 'info' as const }
      case 'not_linked':
        return { label: 'Não vinculado', color: 'secondary' as const }
      case 'error':
        return { label: 'Erro de integração', color: 'error' as const }
      default:
        return { label: status, color: 'secondary' as const }
    }
  }, [status])

  return (
    <Badge variant="soft" color={color}>
      {label}
    </Badge>
  )
}
